/** Поиск по номеру — ровно то, что отдаёт `GET /api/search?q=`. */
import { apiFetch, query } from "@/lib/api";

export type Via =
  | "number" | "bitrix_contact" | "bitrix_lead" | "cache"
  | "crm_contact" | "crm_lead" | "salon_customer" | "contract";

export const VIA: Record<Via, { label: string; hint: string }> = {
  number: { label: "номер", hint: "ввели номер сделки/лида" },
  bitrix_contact: { label: "контакт Bitrix", hint: "crm.duplicate.findbycomm → контакт → сделки, где он основной" },
  bitrix_lead: { label: "лид Bitrix", hint: "crm.duplicate.findbycomm → лид" },
  cache: { label: "кэш", hint: "bitrix_phone / bitrix_deal_contact в prokat" },
  crm_contact: { label: "контакт CRM", hint: "b24ContactDetail → b24Deal_contact → b24Deal (все привязки)" },
  crm_lead: { label: "лид CRM", hint: "b24Lead.phone" },
  salon_customer: { label: "клиент салона", hint: "sCustomer_contact → sCustomer → bitrixDealSync / appCustomerID / manPodbor" },
  contract: { label: "договор", hint: "sCustomer_dogovor.customerPhone" },
};

export type SearchDeal = {
  id: number; title: string | null; stage: string | null; stage_name: string | null; category: string | null;
  active: boolean; created: string | null; assigned: string | null; via: Via[];
};
export type SearchLead = {
  id: number; title: string | null; status: string; status_name: string; active: boolean;
  created: string | null; assigned: string | null; via: Via[];
};
export type SearchContact = { id: number; name: string; phones: string[]; via: Via[] };
export type SearchCustomer = {
  id: number; name: string | null; date_start: string | null; status: string | null; deal_ids: number[]; via: Via[];
};
export type SearchContract = { id: number; deal_id: number | null; customer_id: number | null; status: string | null; via: Via[] };
export type SearchResult = {
  query: string;
  kind: "phone" | "number";
  phones: string[];
  main: { entity: "deal" | "lead"; id: number; reason: string } | null;
  deals: SearchDeal[];
  leads: SearchLead[];
  contacts: SearchContact[];
  customers: SearchCustomer[];
  contracts: SearchContract[];
  errors: string[];
};

export function loadSearch(q: string): Promise<SearchResult> {
  return apiFetch<SearchResult>(`/api/search${query({ q })}`);
}
